"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeselectButton = void 0;
var _react = require("react");
var _Button = _interopRequireDefault(require("../../Button"));
var _RemoveDone = _interopRequireDefault(require("@mui/icons-material/RemoveDone"));
var _constants = require("../constants");
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    button: {
      height: function height(_ref) {
        var rowHeight = _ref.rowHeight;
        return "".concat(rowHeight, "px");
      },
      justifyContent: 'start',
      width: '100%',
      paddingLeft: '16px',
      borderRadius: 0
    }
  };
});
var DeselectButton = exports.DeselectButton = function DeselectButton(_ref2) {
  var renderedOptions = _ref2.renderedOptions,
    onChange = _ref2.onChange,
    rowHeight = _ref2.rowHeight,
    multiple = _ref2.multiple;
  var classes = useStyles({
    rowHeight: rowHeight
  });
  var handleDeselect = (0, _react.useCallback)(function (_e) {
    onChange([]);
  }, [onChange]);
  var someSelected = renderedOptions === null || renderedOptions === void 0 ? void 0 : renderedOptions.some(function (opt) {
    return opt.selected;
  });
  var label = (0, _react.useMemo)(function () {
    if (multiple) {
      return 'Unselect All';
    }
    return 'Deselect';
  }, [multiple]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
    startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemoveDone["default"], {}),
    color: 'primary',
    onClick: handleDeselect,
    className: classes.button,
    "data-cy-action": _constants.dataCyActionDeselect,
    disabled: !someSelected,
    children: label
  });
};